import React, { useEffect, useRef } from 'react';

const PreviewCaseModal = ({ caseItem, onClose }) => {
  const videoRef = useRef(null);
  const closeButtonRef = useRef(null);

  useEffect(() => {
    if (!caseItem) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeButtonRef.current?.focus();

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKeyDown);
      if (videoRef.current) {
        videoRef.current.pause();
      }
    };
  }, [caseItem, onClose]);

  if (!caseItem) return null;

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) onClose();
  };

  return (
    <div
      className="site-refresh__case-modal-backdrop"
      onClick={handleBackdropClick}
      role="presentation"
    >
      <div
        className="site-refresh__case-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="site-refresh-case-modal-title"
      >
        <button
          ref={closeButtonRef}
          type="button"
          className="site-refresh__case-modal-close"
          onClick={onClose}
          aria-label="Fechar"
        >
          ×
        </button>

        <div className="site-refresh__case-modal-video-wrap">
          <video
            ref={videoRef}
            className="site-refresh__case-modal-video"
            src={caseItem.video}
            controls
            autoPlay
            playsInline
          />
        </div>

        <div className="site-refresh__case-modal-body">
          <div className="site-refresh__case-modal-category">{caseItem.category}</div>
          <h3 id="site-refresh-case-modal-title" className="site-refresh__case-modal-title">
            {caseItem.title}
          </h3>
          <p className="site-refresh__intro">{caseItem.longDescription ?? caseItem.description}</p>
        </div>
      </div>
    </div>
  );
};

export default PreviewCaseModal;
